const systemVersion = "1.0.0"

export default systemVersion